import { render, staticRenderFns } from "./ComboOrgao.vue?vue&type=template&id=2786a2a3"
import script from "./ComboOrgao.vue?vue&type=script&lang=js"
export * from "./ComboOrgao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports